import { AddProductToCart } from "components/AddProductToCart/AddProductToCart";
import { Button } from "components/DesignSystem/Button/Button";
import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { EditPencil } from "components/icons/EditPencil";
import { AddCartItem, BULK_CART_ACTIONS } from "constants/BulkCartAction";
import { getIn, useFormikContext } from "formik";
import { useModal } from "hooks/useModal";
import { useState } from "react";
import { MultiValue, SingleValue } from "react-select";
import { useGetBaseTaskTemplatesQuery } from "store/apis/getTemplates";
import { BulkCartActionFormValues } from "./AddDetailsForBulkCartAction";
import { useToast } from "hooks/useToast";

export const SelectBaseTask = ({
  index,
  value,
}: {
  index: number;
  value: string;
}) => {
  const { data, isLoading } = useGetBaseTaskTemplatesQuery({});
  const templates = Object.values(data || {}).flat();
  const { setFieldValue, values, errors, touched, validateForm } =
    useFormikContext<BulkCartActionFormValues>();
  const addTaskModal = useModal();
  const { successToast } = useToast();

  const currentRow = values.rows[index];
  const [modalTemplateId, setModalTemplateId] = useState<string>(
    currentRow.product_id || value || ""
  );

  const taskOptions = templates.map((template) => ({
    value: template.uuid,
    label: template.title,
  }));

  const handleChange = (
    option: MultiValue<OptionData> | SingleValue<OptionData>
  ) => {
    if (option instanceof Array) {
      return;
    }

    if (option?.value) {
      setModalTemplateId(option.value);
      addTaskModal.open();
    }
  };

  const handleFilingAdd = (values: AddCartItem) => {
    (Object.keys(values) as Array<keyof AddCartItem>).forEach((key) => {
      setFieldValue(`rows.${index}.${key}`, values[key]);
    });
    setFieldValue(`rows.${index}.action`, BULK_CART_ACTIONS.ADD_TO_CART);
    addTaskModal.close();
    successToast({ message: "Saved successfully" });
  };

  const fieldName = `rows.${index}.product_id`;

  const handleClose = () => {
    setModalTemplateId(currentRow.product_id || "");
    setFieldValue(fieldName, currentRow.product_id);
    addTaskModal.close();
  };

  const selected = taskOptions.find((opt) => opt.value === value);
  const error = getIn(errors, fieldName);
  const isTouched = getIn(touched, fieldName);

  return (
    <>
      {selected ? (
        <div className="t-flex t-gap-1 t-items-center">
          <div className="t-flex-1 t-truncate t-max-w-56">{selected.label}</div>
          <Button
            customType="ghost"
            size="xsmall"
            onClick={addTaskModal.open}
            type="button"
          >
            <EditPencil className="t-text-text-30" />
          </Button>
        </div>
      ) : (
        <div>
          <Combobox
            name={fieldName}
            placeholder="Select task"
            isLoading={isLoading}
            options={taskOptions}
            value={selected}
            onChange={handleChange}
            size="small"
            fullWidth
            type={error && isTouched ? "error" : undefined}
            menuPortalTarget={document.body}
            components={{
              ClearIndicator: () => null,
            }}
          />
          {error && isTouched && (
            <div className="t-mt-1.5 t-text-body-sm t-text-red">{error}</div>
          )}
        </div>
      )}
      {addTaskModal.isOpen && modalTemplateId && (
        <AddProductToCart
          ignoreCountErrors
          onClose={handleClose}
          productIdFromProps={modalTemplateId}
          handleOwnAdd={handleFilingAdd}
          initialValue={currentRow}
          hideEntity
          submitBtnText={
            currentRow?.product_id && currentRow.season
              ? "Save"
              : "Confirm details"
          }
        />
      )}
    </>
  );
};
